__webpack_require__.p = "/reports-truncate-data-table/referrals-hub/";